import { WeatherConditionProps } from "@whoosh/design-system/src/components/display/WeatherCondition";

export const timeSlotListInternalReducer = (
  state: timeSlotListInternalReducerState,
  action: timeSlotListInternalReducerActions
) => {
  switch (action.type) {
    case "updatePinnedCondition":
      return {
        ...state,
        pinnedWeatherCondition: action.payload,
      } as timeSlotListInternalReducerState;

    default:
      return state;
  }
};

export type timeSlotListInternalReducerActions = {
  type: "updatePinnedCondition";
  payload: WeatherConditionProps | null;
};

export type timeSlotListInternalReducerState = {
  pinnedWeatherCondition?: WeatherConditionProps | undefined | null;
};
